import { render, staticRenderFns } from "./BlockContactModal.vue?vue&type=template&id=2b67859a&"
import script from "./BlockContactModal.vue?vue&type=script&lang=js&"
export * from "./BlockContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports